import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import type { CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

/**
 * Non-blocking feedback for every surface. A toast is the ONLY acknowledgement
 * a scoring path may show: nothing on that path is allowed to open a dialog.
 *
 * `theme` is pinned light rather than read from next-themes: this app has no
 * dark mode (every surface is a light ground with --band as its dark accent),
 * so the dependency existed only to answer a question with one answer.
 *
 * Toasts sit at the BOTTOM on phones. The top of a scorekeeper's screen is the
 * live score, and covering it to say "Undone" hides the very thing the tap was
 * meant to change.
 */
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="light"
      position="bottom-center"
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--band)",
          "--normal-text": "var(--band-foreground)",
          "--normal-border": "var(--band-border)",
          "--border-radius": "var(--radius)",
        } as CSSProperties
      }
      toastOptions={{ classNames: { toast: "cn-toast" } }}
      {...props}
    />
  );
};

export { Toaster };
